import APIService from '../api.service';

export const Login = (body, config = {}) => {
  return APIService.post(`/v01/login`, body, config);
};

export const VerifyLoginOtp = (body, config = {}) => {
  return APIService.post(`/v01/login/otp/verify`, body, config);
};

export const ResendLoginOtp = (body, config = {}) => {
  return APIService.post(`/v01/login/otp/resend`, body, config);
};

export const Logout = () => {
  return APIService.post(`/v01/logout`);
};

export const List = (params) => {
  return APIService.get(`/v01/users`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/users`, body, config);
};

export const UserDetails = (id) => {
  return APIService.get(`/v01/users/${id}`);
};

export const Put = (payload) => {
  return APIService.put(`/v01/users/${payload.id}`, {...payload});
};

export const DeleteUser = (id) => {
  return APIService.delete(`/v01/users/${id}`);
}

export const saveFCMToken = (payload) => {
  return APIService.put(`/v01/saveFCMToken`, {...payload})
}

export const fetchNotification = (payload) => {
  return APIService.get(``)
}

const UserService = {
  Login,
  VerifyLoginOtp,
  ResendLoginOtp,
  Logout,
  List,
  Create,
  UserDetails,
  Put,
  DeleteUser,
  saveFCMToken
};
export default UserService;
